module.exports = __webpack_public_path__ + "img/model-logo1-large.ecb486d0.png";